/**
 * Provides a `Field`-based UI for table column headers.
 * ## Fields
 * Name | Description
 * --- | ---
 * field | The `Field` model represented by the view.
 * filterView | The `FilterView` associated with the view.
 *
 * ## Events
 * Name | Arguments | Description
 * filter | The new filter value. | Fired whenever the filter value changes.
 * sort | The new sort mode. | Fired whenever the sort mode changes.
 */
import Backbone from "backbone";
import _ from "underscore";
import FilterView from "core/views/FilterView";
var ColumnHeaderView = Backbone.View.extend(
  {
    tagName: "th",

    template: _.template(
      '<% if(sortable){%><a class="sort-trigger" href="#"><span class="column-label"><%= label %></span>&nbsp;<span class="sort-mode glyphicon glyphicon-sort"></span></a><% } else { %><%= label %><%}%>'
    ),

    /**
     * Initializes the control
     * @param  {object} options The options hash.
     * @param {Array} options.field The `Field` model to display in the view.
     */
    initialize: function (options) {
      this.options = _.defaults({}, options);

      this.field = this.options.field;
    },

    events: {
      "click a": function () {
        this._updateSort();
      },
    },

    render: function () {
      var field = this.field;
      var label = field.attributes.label;
      var sortable = field.attributes.sortable;

      this.$el.html(
        this.template({
          label: label,
          sortable: sortable !== false,
        })
      );

      field.on(
        "change:label",
        function () {
          this.$(".column-label").html(field.attributes.label);
        },
        this
      );

      if (field.attributes.filterable) {
        var filter = (this.filterView = new FilterView({
          field: this.field,
        }));

        filter.on(
          "value",
          function (value) {
            this.trigger("filter", value);
          },
          this
        );
        filter.render();
        this.$el.prepend(filter.$el);
      }
    },

    _updateSort: function (selectedMode) {
      var sortMode = ColumnHeaderView.SortNone;

      if (!selectedMode) {
        if (typeof this._sortMode != "undefined") {
          sortMode = this._sortMode;
        }

        if (sortMode == ColumnHeaderView.SortNone) {
          sortMode = ColumnHeaderView.SortAscending;
          this.$(".sort-mode")
            .removeClass("glyphicon-sort")
            .addClass("glyphicon-sort-by-alphabet");
        } else if (sortMode == ColumnHeaderView.SortAscending) {
          sortMode = ColumnHeaderView.SortDescending;
          this.$(".sort-mode")
            .removeClass("glyphicon-sort-by-alphabet")
            .addClass("glyphicon-sort-by-alphabet-alt");
        } else if (sortMode == ColumnHeaderView.SortDescending) {
          sortMode = ColumnHeaderView.SortNone;
          this.$(".sort-mode")
            .removeClass("glyphicon-sort-by-alphabet-alt")
            .addClass("glyphicon-sort");
        }
      } else {
        sortMode = selectedMode;
      }

      this.setSort(sortMode);
    },

    /**
     * Clear the filter value, if filtering is supported by the field.
     */
    clearFilter: function () {
      if (this.filterView) {
        this.filterView.resetValue();
      }
    },

    /**
     * Reset the column sort mode.
     */
    clearSort: function () {
      this._sortMode = ColumnHeaderView.SortNone;
    },

    /**
     * Set the column sort mode.
     * @param {string} mode One of `ColumnHeaderView.SortAscending`, `ColumnHeaderView.SortDescending`, or `ColumnHeaderView.SortNone`.
     */
    setSort: function (mode) {
      this._sortMode = mode;
      this.trigger("sort", mode);
    },

    //todo add getSort, revise applicable tests

    /**
     * Set the filter value, if filtering is supported by the field.
     * @param {string|Function} value The filter value. See `FilterView`
     */
    setValue: function (value) {
      if (this.filterView) {
        this.filterView.setValue(value);
      }
    },

    delegateEvents: function () {
      Backbone.View.prototype.delegateEvents.apply(this, arguments);
      if (this.filterView) {
        this.filterView.delegateEvents();
      }
    },
  },
  {
    SortAscending: "ascending",
    SortDescending: "descending",
    SortNone: null,
  }
);

export default ColumnHeaderView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/ColumnHeaderView.js
// module id = 857
// module chunks = 1